@if (vm.fixture) {
    @for (participant of vm.participants; track participant.id) {
        @if (vm.options[participant.id]; as option) {
            <ms-fixture-pick
                class="fixture-pick clearfix"
                trackingSource="RacePage/Antepost"
                [fixture]="vm.fixture"
                [participant]="participant"
                [option]="option"
                [title]="participant.name | msTranslate">
                <ms-antepost-container [vm]="vm" [participant]="participant" [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap" [isSports]="true" />
            </ms-fixture-pick>
        }
    }
}
